document.addEventListener("click", function (event) {
    var trigger = event.target.closest(".readmore, .readless");
    if (!trigger) return;

    var description = trigger.closest(".collection-description");
    if (!description) return;

    event.preventDefault();

    var shortContent = description.querySelector(".short-content");
    var fullContent = description.querySelector(".full-content");
    var expand = trigger.classList.contains("readmore");

    if (shortContent) {
        shortContent.classList.toggle("hideContent", expand);
    }

    if (fullContent) {
        fullContent.classList.toggle("hideContent", !expand);
    }
});
